import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment  } from "./../../environments/environment";
import { ConfigurationService } from './common/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DealersService
 {

  constructor(private http : HttpClient, private config: ConfigurationService) { }





  LTEAllDealers(){
 
    
      let url = `${environment.lteHttpBaseUrl}/api/Dealers/Get/getdealers`;
      
      return this.http.get<any>(url);
    
    }



}
